import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-write",
  "use": "default-write-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"default-write\"><path fill-rule=\"evenodd\" d=\"M10.044 30.111l.587.586-1.404.202-.28.272-.196-.203-8.42 1.212 1.465-10.3 1.168 1.166L18.72 7.832l-.052-.053 5.036-4.863 6.946 7.193-3.051 2.947.051.053-17.605 17.002zM22.04 7.301l4.168 4.316 1.612-1.557-4.168-4.316-1.612 1.557zm2.235 6.286L20.108 9.27 4.828 24.027l4.168 4.316 15.28-14.756zM12 31h24v2H12v-2zm-9.313-1.18l3.7-.532-3.174-3.168-.526 3.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol